<iframe class="files-auth-frame" #authFrame [src]="imageURL"></iframe>
